import { BasicTeamDetails } from '@alienheadwars/football-card-manager-model';
import { Card } from '@mui/material';
import { useState } from 'react';
import { defaultColours } from '../CardColours';
import { InlineCardComponent } from '../InlineCard';
import { CardDimensions } from '../playerCards/CardDimensions';

export interface TeamCardProps {
  team: BasicTeamDetails;
  dimensions: CardDimensions;
  avatarSide?: 'left' | 'right';
  additionalChildren?: any;
}

export const TeamCard = (props: TeamCardProps) => {
  const { team, dimensions, avatarSide } = props;
  const [imageLoaded, setImageLoaded] = useState(true);
  const colours = props.team.colours ?? defaultColours;
  const avatar = (
    <Card
      sx={{
        backgroundColor: colours.primaryBackgroundColour,
        width: dimensions.cardWidth,
        height: dimensions.cardWidth,
      }}
    >
      {imageLoaded && (
        <img
          src={`/images/badges/${team.id}.png`}
          alt={team.id}
          style={{ width: dimensions.cardWidth }}
          onError={() => setImageLoaded(false)} // Set the state to show the backup if there's an error
        />
      )}
      {/* Conditionally render the backup badge */}
      {!imageLoaded && (
        <img
          src={`/images/badges/fallback.png`} // Replace with your fallback image path
          alt="Fallback Badge"
          style={{ width: dimensions.cardWidth }}
        />
      )}
    </Card>
  );
  return (
    <InlineCardComponent
      avatar={avatar}
      colours={colours}
      dimensions={dimensions}
      title={team.name}
      avatarSide={avatarSide}
      additionalChildren={props.additionalChildren}
    />
  );
};
